module.exports = __webpack_public_path__ + "img/selected5-min.77b37fd4.png";